import { render, staticRenderFns } from "./reviseRecordAdd.vue?vue&type=template&id=c60bea74&"
import script from "./reviseRecordAdd.vue?vue&type=script&lang=js&"
export * from "./reviseRecordAdd.vue?vue&type=script&lang=js&"
import style0 from "./reviseRecordAdd.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports